module.exports = __webpack_public_path__ + "img/82e075f88e0f4dbab1a75e24ef1a7736-1440.f0133fb0.jpg";